<template>
  <v-row>
    <v-col cols="10">
      <word-list-config
        :words="words"
        :disabled="questionHasResponses"
        @words-updated="wordsUpdated"
      />
    </v-col>

    <v-col cols="2">
      <v-row class="d-flex flex-row-reverse">
        <word-settings-controller
          :count="wordCount"
          :range="config.wordRange"
          title="Words"
          :disabled="questionHasResponses"
          @set-value="setWordCount"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import WordListConfig from './WordListConfig';
import WordSettingsController from './WordSettingsController';
export default {
  name: 'PieChartConfig',
  components: { WordListConfig, WordSettingsController },
  props: {
    value: {
      type: Object,
      required: true
    },
    questionHasResponses: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      words: this.value.options,
      wordCount: this.value.options.length,
      config: {
        wordRange: { min: 3, max: 8 }
      }
    };
  },
  computed: {
    ...mapGetters('survey', ['primaryLanguage'])
  },
  methods: {
    configUpdated() {
      const config = {
        options: this.words,
        questionType: this.value.questionType
      };
      this.$emit('input', config);
      this.$emit('change', config);
    },
    wordsUpdated() {
      this.configUpdated();
    },
    setWordCount(wordCount) {
      this.wordCount = wordCount;
      this.adjustWordInputsToMatchCount();
      this.configUpdated();
    },
    adjustWordInputsToMatchCount() {
      if (this.words.length < this.wordCount) {
        while (this.words.length < this.wordCount) {
          this.addEmptyWord();
        }
      } else if (this.words.length > this.wordCount) {
        while (this.words.length > this.wordCount) {
          this.removeLastWord();
        }
      }
    },
    addEmptyWord() {
      this.words.push({
        languageMap: { [this.primaryLanguage]: '' }
      });
    },
    removeLastWord() {
      this.words.pop();
    }
  }
};
</script>
